/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB',
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      // 更新提示
      ELEMENT.Notification.warning({
        title: '更新通知',
        dangerouslyUseHTMLString: true,
        message: '<span>新版本已准备就绪，</span>' +
          '<button type="button" class="el-button el-button--text" style="padding: 5px 0;" onclick="updateVersionNow()">' +
          '<span>立即更新</span>' +
          '</button>',
        duration: 0,
        offset: 55,
      })
      // 确认更新动作
      window.updateVersionNow = function () {
        ELEMENT.MessageBox.confirm('更新版本将会刷新当前页面, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(function () {
          if (registration.waiting) {
            // 等待加载画面
            ELEMENT.Loading.service({
              fullscreen: true,
              text: '更新中……',
            })
            /**
             * 跳过等待，进入新版本
             * https://github.com/vuejs/vue-cli/issues/3704
             */
            registration.waiting.postMessage({
              type: 'SKIP_WAITING',
            })
            /**
             * 监听状态变化
             * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
             */
            registration.waiting.addEventListener('statechange', function (e) {
              if (e.target.state === 'activated') {
                location.reload()
              }
            })
          } else {
            location.reload()
          }
        })
      }
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    },
  })
}
